import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router";
import moment from "moment";
import { Col, FormGroup, Label, Row, Input, FormFeedback } from "reactstrap";
import Select from "react-select";
import NumberFormat from "react-number-format";
import Datetime from "react-datetime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import WarningModal from "components/UI/WarningModal";
import {
  BASE_URL,
  API,
  FRONT_DF_1,
  BACKEND_DF,
  RESOLUCION_APROBADA,
  RESOLUCION_APROBADA_PARCIAL,
  RESOLUCION_RECHAZADA,
  RESOLUCION_REDUCIDA,
  PROFILES,
  RESOLUCION_BLOQUEADA,
  TIPO_MOVIMIENTO_LINEA_CREDITO,
  ADMIN_ROLES,
  RAMO_FECU_CREDITO_EXPORTACION_NEMOTECNICO,
  MAX_MONTOS_PERMITIDOS_BY_PROFILE
} from "CONST";
import { get, patch, post } from "helpers/requests";
import { formatRut, fdate, fileDownload, roundInt, formatSpanishNumber } from "helpers/helpers";
import { motivosToOption } from "helpers/selects";
import Icon from "components/UI/Icon";
import store from "redux-store/store";
import isUserHasProfile from "helpers/profileValidator";
import { RESOLUCIONES_WRITE } from "helpers/profilePermission";
import InfoCard from "components/shared/InfoCard";
import SafeBtn from "../shared/SafeBtn";
import CheckModal from "../shared/CheckModal";
import ComentarioResolucionTable from "./ComentarioResolucionTable";
import ComentarioResolucionModal from "./ComentarioResolucionModal";
import CarpetaResolucionModal from "./CarpetaResolucionModal";
import 'styles/resolucion.css';


const ResolucionForm = () => {
  const [movimiento, setMovimiento] = useState(null);
  const [optionsMotivoResolucion, setOptionsMotivoResolucion] = useState(null);
  const [poliza, setPoliza] = useState(null);
  // datos formulario
  const [warningTecho, setWarningTecho] = useState(false);
  const [cumuloDisponible, setCumuloDisponible] = useState(0);
  // datos deudor
  const [motivoResolucion, setMotivoResolucion] = useState(null);
  const [inicioVigenciaLinea, setInicioVigenciaLinea] = useState(null);
  const [finVigenciaLinea, setFinVigenciaLinea] = useState(null);
  const [inicioVigenciaPoliza, setInicioVigenciaPoliza] = useState(null);
  const [finVigenciaPoliza, setFinVigenciaPoliza] = useState(null);
  const [monedaAsegurada, setMonedaAsegurada] = useState("UF");
  const [resolucion, setResolucion] = useState(null);
  const [comentarioAnalista, setComentarioAnalista] = useState("");
  const [comentarioAsegurado, setComentarioAsegurado] = useState("");
  const [montoOtorgado, setMontoOtorgado] = useState(0);
  const [montoSolicitado, setMontoSolicitado] = useState(0);
  const [montoVigente, setMontoVigente] = useState(0);
  // validación
  const [isValidMotivo, setIsValidMotivo] = useState(false);
  const [isValidInicioVigenciaLinea, setIsValidInicioVigenciaLinea] = useState(true);
  const [isValidFinVigenciaLinea, setIsValidFinVigenciaLinea] = useState(true);
  const [isValidRangoFecha, setIsValidRangoFecha] = useState(true);
  const [isValidResolucion, setIsValidResolucion] = useState(true);
  const [isValidUserAndProfile, setIsValidUserAndProfile] = useState(true);
  const [isValidMontoSolicitado, setIsValidMontoSolicitado] = useState(true);
  const [invalidMontoError, setInvalidMontoError] = useState(true);
  const [rechazadoConComentario, setRechazadoConComentario] = useState(true)
  // modal
  const [showModal, setShowModal] = useState(false);
  const [modalErrorMessage, setModalErrorMessage] = useState("");
  const [showResolveModal, setShowResolveModal] = useState(false);
  // modal reporte consolidado
  const [openWarningModal, setOpenWarningModal] = useState(false);
  // modal comentarios solicitud
  const [showSaveComment, setShowSaveComment] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [resolveLoading, setResolveLoading] = useState(false);

  // Notificables
  const [notificables, setNotificables] = useState([]);

  // Carpeta Tributaria
  const [carpetaTributaria, setCarpetaTributaria] = useState(null);
  const [showCarpetaModal, setShowCarpetaModal] = useState(false);
  const [showCarpetaWarning, setShowCarpetaWarning] = useState(false);

  const { id } = useParams();
  const history = useHistory();
  const [tipoDeudor, setTipoDeudor] = useState('');
  const [evaluacion, setEvaluacion] = useState('');

  const isExportacion = poliza?.ramo_asegurado_nemotecnico === RAMO_FECU_CREDITO_EXPORTACION_NEMOTECNICO;
  const isChilean = !movimiento?.pais_deudor_code || movimiento?.pais_deudor_code === 'CL';

  const resolutionData = (resolver) => {
    let montoOtorgadoResolution;
    let montoVigenteResolution;
    if (resolucion === RESOLUCION_APROBADA) {
      montoOtorgadoResolution = movimiento.linea_solicitada
      montoVigenteResolution = movimiento.linea_solicitada
    }
    else if (resolucion === RESOLUCION_APROBADA_PARCIAL) {
      montoOtorgadoResolution = montoOtorgado
      montoVigenteResolution = montoOtorgado
    }
    else {  // resolucion === RESOLUCION_RECHAZADA
      montoOtorgadoResolution = 0
      montoVigenteResolution = 0
    }
    
    const data = {
      fecha_vigencia: moment(inicioVigenciaLinea, FRONT_DF_1).format(BACKEND_DF),
      fecha_fin_vigencia: moment(finVigenciaLinea, FRONT_DF_1).format(BACKEND_DF),
      comentario_analista: comentarioAnalista,
      comentario_asegurado: comentarioAsegurado,
      motivo: motivoResolucion && motivoResolucion.motivo.descripcion,
      resuelto: resolver,
      monto_otorgado: montoOtorgadoResolution,
      monto_vigente: montoVigenteResolution,
      score: movimiento.score
    };

    if (resolver) {
      data.fecha_respuesta = moment().format(BACKEND_DF);
    }

    if (movimiento.resolucion) {
      data.resolucion.id = movimiento.resolucion.id;
    }

    if (resolucion) {
      data.estado = resolucion;
    }

    return data;
  };

  const PROFILE_TO_MONTO_KEY = {
      [PROFILES.analistaRiesgoCreditoJr]: 'analistaRiesgoCreditoJr',
      [PROFILES.analistaRiesgoCreditoSr]: 'analistaRiesgoCreditoSr',
      [PROFILES.subgerenteRiesgoCredito]: 'subgerenteRiesgoCredito',
      [PROFILES.gerenteRiesgoCredito]: 'gerenteRiesgoCredito',
      [PROFILES.actuariado]: 'actuariado',
    };

  const validateMontoSolicitado = (mov) => {
    if (mov) {
      if (isExportacion && !isUserHasProfile([PROFILES.gerenteRiesgoCredito, PROFILES.ceo])) {
        setInvalidMontoError('No tiene permitido resolver para pólizas de exportación.');
        return false;
      }

      if (isUserHasProfile(ADMIN_ROLES)) {
        return true;
      }

      const montoResolucion = (resolucion === RESOLUCION_APROBADA)
        ? mov.linea_solicitada
        : montoOtorgado

      const limitesByMoneda = MAX_MONTOS_PERMITIDOS_BY_PROFILE[monedaAsegurada];

      const montosAplicables = Object.entries(PROFILE_TO_MONTO_KEY)
        .filter(([profile]) => isUserHasProfile([profile]))
        .map(([, montoKey]) => limitesByMoneda[montoKey]);

      if (montosAplicables.length > 0) {
        // El PERFIL más restrictivo aplica
        const maxMonto = Math.min(...montosAplicables);
        if (montoResolucion <= maxMonto) {
          return true;
        }
        setInvalidMontoError(`No tiene permitido resolver para monto mayor a ${formatSpanishNumber(maxMonto)} ${monedaAsegurada}.`);
        return false;
      }
      return false;
    }
    return true
  }

  const validateUserAndProfile = (mov) => {
    const state = store.getState();
    let analista = null;
    if (mov) {
      analista = mov.analista;
    }
    // reviso si tengo permisos administrativos y no es analista
    if (isUserHasProfile(RESOLUCIONES_WRITE) && !isUserHasProfile([PROFILES.analistaRiesgoCredito])) {
      setIsValidUserAndProfile(true);
      return;
    }
    // reviso si hay analista
    if (analista) {
      // obtengo datos del analista y datos del usuario logeado
      const userMail = state.login.user.email;
      const analistaMail = analista.user.email;

      // si el analista es el usuario loggeado
      if (userMail === analistaMail && isUserHasProfile([PROFILES.analistaRiesgoCredito])) {
        setIsValidUserAndProfile(true);
        return;
      }
    }
    setIsValidUserAndProfile(false);
  };

  const getMovimiento = (firstExecution = false) => {
    get(`${BASE_URL}${API.resolucion}/${id}/`).then((response) => {
      setMovimiento(response);
      setInicioVigenciaLinea(moment(
        response.fecha_vigencia ? response.fecha_vigencia : response.fecha_solicitud
      ));
      setFinVigenciaLinea(moment(
        response.fecha_fin_vigencia ? response.fecha_fin_vigencia : response.fecha_termino_poliza
      ));
      setInicioVigenciaPoliza(moment(response.fecha_vigencia_poliza));
      setFinVigenciaPoliza(moment(response.fecha_termino_poliza));
      if (firstExecution) {
        setComentarioAnalista(response.comentario_analista);
        setComentarioAsegurado(response.comentario_asegurado);
      }
      setMonedaAsegurada(response.moneda_asegurada || 'UF')
      setMontoSolicitado(response.linea_solicitada);
      setMontoVigente(response.monto_vigente);

      if (response.estado && response.estado !== RESOLUCION_APROBADA) {
        setMontoOtorgado(response.monto_otorgado);
      }

      // Se valida usuario una vez se tenga el movimiento.
      validateUserAndProfile(response);
    });
  }

  useEffect(() => {
    if (!movimiento) return;

    get(`${BASE_URL}${API.lineacredito}/?linea_credito_id=${movimiento.linea_credito}`)
      .then((tipoDeudorResponse) => {
        if (tipoDeudorResponse) {
          setTipoDeudor(tipoDeudorResponse.tipo_deudor_nombre);
        }
      })
      .catch((error) => {
        console.error('Error en peticion de deudor:', error);
      });
  }, [movimiento]);


  useEffect(() => {
    setRechazadoConComentario(resolucion === RESOLUCION_APROBADA || !!(comentarioAsegurado))
  }, [resolucion, comentarioAsegurado])

  useEffect(() => {
    get(`${BASE_URL}${API.motivosResolucion}/`).then((response) =>
      setOptionsMotivoResolucion(motivosToOption(response)),
    );
    get(`${BASE_URL}${API.notificablesCredito}/`).then((response) => {
      setNotificables(response.results);
    })
    getMovimiento(true);
  }, [id]);

  useEffect(() => {
    let cumuloDisponibleTemp = cumuloDisponible;
    if (movimiento && !cumuloDisponibleTemp) {
      get(`${BASE_URL}${API.deudor}/${movimiento.id_deudor}/?incluir_cumulo=true`).then((response) => {
        cumuloDisponibleTemp = (response.techo_vigente ?
          response.techo_vigente - response.linea_vigente + movimiento.monto_vigente : -1);
        setCumuloDisponible(cumuloDisponibleTemp);
      });
    }
    setWarningTecho(cumuloDisponibleTemp >= 0 && montoOtorgado > cumuloDisponibleTemp && montoSolicitado >= montoOtorgado);
  }, [movimiento, montoOtorgado, resolucion]);

  // Validaciones

  useEffect(() => {
    setIsValidInicioVigenciaLinea(inicioVigenciaLinea !== null);
  }, [inicioVigenciaLinea]);

  useEffect(() => {
    setIsValidFinVigenciaLinea(finVigenciaLinea !== null);
  }, [finVigenciaLinea]);

  useEffect(() => {
    setIsValidRangoFecha(inicioVigenciaLinea < finVigenciaLinea);
  }, [inicioVigenciaLinea, finVigenciaLinea]);

  useEffect(() => {
    setIsValidResolucion(resolucion !== null);
    setIsValidMontoSolicitado(validateMontoSolicitado(movimiento));
  }, [resolucion]);

  useEffect(() => {
    setIsValidMotivo(motivoResolucion !== null);
  }, [motivoResolucion]);

  useEffect(() => {
    setIsValidMontoSolicitado(validateMontoSolicitado(movimiento));
  }, [montoOtorgado]);

  const toggleModal = (event) => {
    if (event) {
      event.preventDefault();
    }
    setOpenModal(!openModal);
  };

  const toggleWarningModal = () => {
    setOpenWarningModal(false);
  }

  const onResolution = () => {
    const data = resolutionData(true);
    setResolveLoading(true);
    patch(`${BASE_URL}${API.riskInbox}/asignar-analista/`, [{ "id": movimiento.id }])
      .then(([response]) => {
        if (response.analista_id) {
          if (resolucion === RESOLUCION_REDUCIDA) {
            const resolveData = {
              ...data,
              estado: 'reducida',
              monto_otorgado: montoOtorgado,
              monto_vigente: montoOtorgado,
              fecha_respuesta: moment().format(BACKEND_DF),
              resuelto: true,
              comentario_asegurado: comentarioAsegurado,
              analista_id: response.analista_id
            };
                
            post(`${BASE_URL}${API.resolucion}/${id}/resolver/`, resolveData)
              .then(() => {
                setShowResolveModal(true);
              })
              .catch((error) => {
                if (error?.status === 409 || error?.response?.status === 409) {
                  setModalErrorMessage("Esta solicitud ya fue resuelta por otro usuario.");
                } else {
                  setModalErrorMessage("Actualización de la resolución");
                }
                setShowModal(true);
              })
              .finally(() => {
                setResolveLoading(false);
              });
          } else {
            post(`${BASE_URL}${API.resolucion}/${id}/resolver/`, data)
              .then((secondResponse) => {
                if (secondResponse.resuelto) {
                  setShowResolveModal(true);
                }
              })
              .catch((error) => {
                if (error?.status === 409 || error?.response?.status === 409) {
                  setModalErrorMessage("Esta solicitud ya fue resuelta por otro usuario.");
                } else {
                  setModalErrorMessage("Actualización de la resolución");
                }
                setShowModal(true);
              })
              .finally(() => {
                setResolveLoading(false);
              });
          }
        }
      })
      .catch((error) => {
        if (error?.status === 409 || error?.response?.status === 409) {
          setModalErrorMessage("Esta solicitud ya fue resuelta por otro usuario.");
        } else {
          setModalErrorMessage("Asignación Analista");
        }
        setShowModal(true);
        setResolveLoading(false);
      });
  };


  const validInitialDates = (current) => {
    if (finVigenciaLinea > inicioVigenciaPoliza) {
      return inicioVigenciaPoliza <= current && current <= finVigenciaLinea;
    }
    return finVigenciaLinea <= current && current <= inicioVigenciaPoliza;
  }

  const validEndDates = (current) => {
    if (inicioVigenciaLinea > finVigenciaPoliza) {
      return finVigenciaPoliza <= current && current <= inicioVigenciaLinea;
    }
    return inicioVigenciaLinea <= current && current <= finVigenciaPoliza;
  }

  const handleDownload = (documentType) => {
    const baseUrl = `${BASE_URL}${API.resolucion}/${id}/`;
    const urlByType = documentType === "carpeta-tributaria" ? "tributaria" : "download";
    const url = `${baseUrl}${urlByType}`;

    fileDownload(url, "");
  };

  const actualizarCarpetaTributaria = () => {
    patch(`${BASE_URL}${API.resolucion}/${id}/update-tributaria/`, { "uuid_tributaria": carpetaTributaria.uuid })
      .then(() => {
        setShowCarpetaModal(true);
      })
      .catch(() => {
        setShowCarpetaWarning(true);
      })
  }

  const checkIsValid = () => (
    isValidInicioVigenciaLinea &&
    isValidFinVigenciaLinea &&
    isValidMontoSolicitado &&
    isValidUserAndProfile &&
    isValidRangoFecha &&
    isValidResolucion &&
    (resolucion === RESOLUCION_APROBADA || isValidMotivo) &&
    // (resolucion !== RESOLUCION_APROBADA_PARCIAL || montoOtorgado > montoVigente) &&
    (resolucion !== RESOLUCION_APROBADA_PARCIAL || montoOtorgado < montoSolicitado)
  )

  useEffect(() => {
    if (!movimiento) {
      return;
    }
    Promise.all([
      // El rating se lee desde BurosHub
      get(`${BASE_URL}${API.ratingBuroshub}/?rut=${encodeURIComponent(movimiento.rut_deudor)}`),
      get(`${BASE_URL}${API.lineacredito}/poliza/?linea_id=${movimiento.linea_credito}`),
    ])
      .then(([clasificacionesResponse, lineacreditoPolizaResponse]) => {
        if (clasificacionesResponse && clasificacionesResponse.length > 0) {
          setEvaluacion(clasificacionesResponse[0].valor);
        }

        if (lineacreditoPolizaResponse) {
          setPoliza(lineacreditoPolizaResponse);
        }
      })
      .catch((error) => {
        console.error('Error en peticion:', error);
      });
  }, [movimiento]);

  return (
    movimiento && poliza && (
      <>
        <Col
          md={{ offset: 1, size: 10 }}
        >
          <Row className="mb-4">
            <Col md={4}>
              <InfoCard
                title="Información Póliza"
                headerStyle={{
                  background: 'var(--orsan-dark-grey)',
                  padding: '0.5rem'
                }}
                items={[
                  {
                    label: 'Póliza',
                    labelFor: 'poliza',
                    value: <p id="poliza">{poliza?.nemotecnico}</p>
                  },
                  {
                    label: 'Moneda',
                    labelFor: 'moneda',
                    value: <p id="moneda">{monedaAsegurada}</p>
                  },
                  {
                    label: 'Asegurado',
                    labelFor: 'asegurado',
                    value: <p id="asegurado">{movimiento.asegurado.nombre}</p>
                  },
                  {
                    label: 'Actividad Económica',
                    labelFor: 'actividad_economica',
                    value: <p id="actividad_economica">{poliza?.actividad_economica}</p>
                  },
                  {
                    label: 'Fecha Fin de Cobertura',
                    labelFor: 'fecha_fin_cobertura',
                    value: <p id="actividad_economica">{fdate(movimiento?.fecha_termino_poliza)}</p>
                  },
                ]}
              />
            </Col>
            <Col md={4}>
              <InfoCard
                title="Solicitud"
                headerStyle={{
                  padding: '0.5rem'
                }}
                items={[
                  {
                    label: 'Fecha de Solicitud',
                    labelFor: 'fecha_solicitud',
                    value: (
                      <p id="fecha_solicitud">{fdate(movimiento?.fecha_solicitud)}</p>
                    )
                  },
                  {
                    label: 'Tipo de Solicitud',
                    labelFor: 'tipo_solicitud',
                    value: (
                      <p id="tipo_solicitud">{movimiento?.tipo_descripcion}</p>
                    )
                  },
                  {
                    label: 'Deudor',
                    labelFor: 'deudor',
                    value: <p id="deudor">{movimiento?.nombre_deudor}</p>
                  },
                  ...(!isChilean ? [{
                    label: 'País Deudor',
                    labelFor: 'pais_deudor',
                    value: <p id="pais_deudor">{movimiento?.pais_deudor_name}</p>
                  }] : []),
                  {
                    label: isChilean ? 'Rut Deudor' : 'N° Documento Deudor',
                    labelFor: 'rut_deudor',
                    value: <p id="rut_deudor">{isChilean ? formatRut(movimiento?.rut_deudor) : movimiento?.rut_deudor}</p>
                  },
                  {
                    label: 'Clasificación',
                    labelFor: 'clasificacion',
                    value: <p id="clasificacion">{tipoDeudor}</p>
                  },
                  {
                    label: 'Observación del Asegurado',
                    labelFor: 'observacion_asegurado',
                    value: <p id="observacion_asegurado">{movimiento?.observacion_asegurado || '---'}</p>
                  },
                ]}
              />
            </Col>
            <Col md={4}>
              <table className='mb-3 mx-auto table-montos'>
                <thead>
                  <tr className='text-center table-header'>
                    <th style={{width: '50%'}}>Monto Solicitado ({monedaAsegurada})</th>
                    <th style={{width: '50%'}}>Monto Vigente ({monedaAsegurada})</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{roundInt(movimiento.linea_solicitada)}</td>
                    <td>{roundInt(movimiento.monto_vigente)}</td>
                  </tr>
                </tbody>
              </table>
              {!isExportacion && (
                <InfoCard
                  title='Resultado Motor'
                  noBorder={false}
                  headerStyle={{
                    padding: '0.5rem'
                  }}
                  items={[
                    {
                      label: 'Resolución',
                      labelFor: 'resultado_motor',
                      value: (
                        <div className='d-flex align-content-center'>
                          {movimiento.razones_motor_riesgo.length && 
                            !movimiento.razones_motor_riesgo.some(razon => 
                              razon.toLowerCase().includes("lista blanca")
                            ) ? (
                              <div className="resultado-motor-pill resultado-motor-pill--rechazado">
                                Rechazado
                              </div>
                            ) : (
                              <div className="resultado-motor-pill resultado-motor-pill--aprobado">
                                Aprobado
                              </div>
                          )}
                          <Icon
                            id="resolucion_motor"
                            className="p-0 ml-1"
                            tooltipText={movimiento?.razones_motor_riesgo?.length ? (
                              <ul>
                                {movimiento.razones_motor_riesgo.map((razonMotor, index) => (
                                  <li key={`${razonMotor}-${index}`}>{razonMotor}</li>
                                ))}
                              </ul>
                            ) : (
                              <p>---</p>
                            )}
                          >
                            <FontAwesomeIcon
                              icon={faExclamationCircle}
                              style={{ color: 'var(--orsan-blue)', fontSize: '18px', margin: 0 }}
                            />
                          </Icon>
                        </div>
                      ),
                    },
                    {
                      label: 'Score Motor',
                      labelFor: 'score_motor',
                      value: movimiento.score !== null ? (
                        <NumberFormat
                          id="score_motor"
                          displayType="text"
                          value={movimiento.score}
                        />
                      ) : "---"
                    },
                    {
                      label: 'Rating',
                      labelFor: 'rating',
                      value: <p id="rating">{evaluacion || "---"}</p>
                    }
                  ]}
                />
              )}
            </Col>
          </Row>

          <hr style={{ marginTop: 20, marginBottom: 30 }} />

          <div className="d-flex justify-content-between">
            <Label>
              <strong>Comentarios Internos</strong>
            </Label>
            <div>
              <SafeBtn
                outline
                className="btn-orsan"
                block
                onClick={toggleModal}
                style={{
                  width: 'auto',
                  marginTop: '-0.5rem',
                }}
              >
                Agregar comentario
              </SafeBtn>
            </div>
          </div>
          <ComentarioResolucionTable
            data={movimiento.comentarios}
          />

          <hr style={{ marginTop: 20, marginBottom: 30 }} />

          <Row style={{ fontWeight: '600', marginBottom: 30 }}>
            <FormGroup className="radio-with-border">
              <Label check>
                <Input
                  type="radio"
                  value="aprobado"
                  checked={resolucion === RESOLUCION_APROBADA}
                  onChange={(event) => {
                    setResolucion(event.target.value);
                    setMotivoResolucion(null);
                    setMontoOtorgado(montoSolicitado);
                  }}
                />
                Aprobada
              </Label>
            </FormGroup>
            <FormGroup className="radio-with-border">
              <Label check>
                <Input
                  type="radio"
                  value="aprobado-parcial"
                  checked={resolucion === RESOLUCION_APROBADA_PARCIAL}
                  onChange={(event) => {
                    setResolucion(event.target.value); // "Aprobado Parcial"
                    setMotivoResolucion(null);
                  }}
                />
                Aprobada Parcial
              </Label>
            </FormGroup>
            {(false) && (
              <FormGroup className="radio-with-border">
                <Label check>
                  <Input
                    type="radio"
                    value="reducir"
                    checked={resolucion === RESOLUCION_REDUCIDA}
                    onChange={(event) => {
                      setResolucion(event.target.value);
                      setMotivoResolucion(null);
                      setMontoOtorgado(0);
                    }}
                    disabled={!montoVigente || montoVigente === 0 || montoVigente === null}
                    show="false"
                  />
                  Reducir
                </Label>
              </FormGroup>
            )}
            <FormGroup className="radio-with-border">
              {movimiento.tipo_descripcion !== TIPO_MOVIMIENTO_LINEA_CREDITO.desbloqueo && (
                <Label check>
                  <Input
                    type="radio"
                    value="rechazado"
                    checked={resolucion === RESOLUCION_RECHAZADA}
                    onChange={(event) => {
                      setResolucion(event.target.value);
                      setMotivoResolucion(null);
                      setMontoOtorgado(0);
                    }}
                  />
                  Rechazada
                </Label>
              )}
            </FormGroup>
            {movimiento.tipo_descripcion === TIPO_MOVIMIENTO_LINEA_CREDITO.desbloqueo && (
              <FormGroup className="radio-with-border">
                <Label check>
                  <Input
                    type="radio"
                    value="rechazado"
                    checked={resolucion === RESOLUCION_RECHAZADA}
                    onChange={(event) => {
                      setResolucion(event.target.value);
                      setMotivoResolucion(null);
                      setMontoOtorgado(0);
                    }}
                  />
                  Rechazada
                </Label>
              </FormGroup>
            )}
          </Row>
          <Row className="mb-3">
            <Col>
              <FormGroup>
                <Label for="motivo" style={{ fontWeight: 600 }}>Motivo</Label>
                <Select
                  id="motivo"
                  name="motivo"
                  className="custom-policy-select"
                  options={optionsMotivoResolucion}
                  onChange={(event) => {
                    setMotivoResolucion(event);
                  }}
                  value={motivoResolucion}
                  placeholder="Seleccione Motivo"
                  isDisabled={resolucion === RESOLUCION_APROBADA}
                  maxMenuHeight={200}
                />
                {resolucion && resolucion !== RESOLUCION_APROBADA && !isValidMotivo && (
                  <FormFeedback style={{ fontSize: "12px" }}>
                    Ingrese un motivo.
                  </FormFeedback>
                )}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label for="monto-parcial" style={{ fontWeight: 600 }}>Monto Parcial</Label>
                <div>
                  <NumberFormat
                    id="monto-parcial"
                    className="form-control"
                    decimalScale="0"
                    decimalSeparator={false}
                    thousandSeparator="."
                    allowNegative={false}
                    value={montoOtorgado}
                    onValueChange={(values) => {
                      setMontoOtorgado(values.floatValue);
                    }}
                    disabled={resolucion !== RESOLUCION_APROBADA_PARCIAL && resolucion !== RESOLUCION_REDUCIDA}
                  />
                </div>
                {(resolucion !== RESOLUCION_RECHAZADA && resolucion !== RESOLUCION_BLOQUEADA) && !montoOtorgado && (
                  <FormFeedback style={{ fontSize: "12px" }}>
                    Debe especificar un monto.
                  </FormFeedback>
                )}
                {(resolucion !== RESOLUCION_RECHAZADA && resolucion !== RESOLUCION_BLOQUEADA) && (poliza && montoOtorgado < poliza.umbral_cobertura_amt) && (
                  <FormFeedback style={{ fontSize: "12px" }}>
                    {`Monto debe ser superior al umbral de cobertura de la póliza de ${poliza.umbral_cobertura_amt} ${monedaAsegurada}`}
                  </FormFeedback>
                )}
                {/*
                {resolucion === RESOLUCION_APROBADA_PARCIAL && montoOtorgado <= montoVigente && (
                  <FormFeedback style={{ fontSize: "12px" }}>
                    Monto parcial debe ser mayor a monto vigente. (
                    {roundInt(montoVigente)}
                    )
                  </FormFeedback>
                )}
                */}
                {resolucion === RESOLUCION_APROBADA_PARCIAL && montoOtorgado >= montoSolicitado && (
                  <FormFeedback style={{ fontSize: "12px" }}>
                    Monto parcial debe ser menor a monto solicitado. (
                    {roundInt(montoSolicitado)}
                    )
                  </FormFeedback>
                )}
                {/*
                {resolucion === RESOLUCION_REDUCIDA && montoOtorgado <= 0 && (
                  <FormFeedback style={{ fontSize: "12px" }}>
                    Monto reducido debe ser mayor a 0 y menor a monto vigente. (
                    {roundInt(montoVigente)}
                    )
                  </FormFeedback>
                )}
                {resolucion === RESOLUCION_REDUCIDA && montoOtorgado >= montoVigente && (
                  <FormFeedback style={{ fontSize: "12px" }}>
                    Monto reducido debe ser menor a monto vigente. (
                    {roundInt(montoVigente)}
                    )
                  </FormFeedback>
                )}
                */}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label for="fechaInicioVigenciaLinea" style={{ fontWeight: 600 }}>Inicio Vigencia Línea</Label>
                <div>
                  <Datetime
                    id="fechaInicioVigenciaLinea"
                    onChange={(value) => setInicioVigenciaLinea(value)}
                    value={inicioVigenciaLinea}
                    dateFormat={FRONT_DF_1}
                    timeFormat={false}
                    closeOnSelect
                    inputProps={{ required: true }}
                    isValidDate={validInitialDates}
                  />
                  {!isValidInicioVigenciaLinea && (
                    <FormFeedback style={{ fontSize: "12px" }}>
                      Ingrese una fecha.
                    </FormFeedback>
                  )}
                </div>
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label for="fechaFinVigenciaLinea" style={{ fontWeight: 600 }}>Fin Vigencia Línea</Label>
                <div>
                  <Datetime
                    id="fechaFinVigenciaLinea"
                    onChange={(value) => setFinVigenciaLinea(value)}
                    value={finVigenciaLinea}
                    dateFormat={FRONT_DF_1}
                    timeFormat={false}
                    closeOnSelect
                    inputProps={{ required: true }}
                    isValidDate={validEndDates}
                  />
                  {!isValidFinVigenciaLinea && (
                    <FormFeedback style={{ fontSize: "12px" }}>
                      Ingrese una fecha.
                    </FormFeedback>
                  )}
                  {!isValidRangoFecha && (
                    <FormFeedback style={{ fontSize: "12px" }}>
                      Fecha de fin vigencia debe ser mayor a inicio vigencia.
                    </FormFeedback>
                  )}
                </div>
              </FormGroup>
            </Col>
          </Row>
          <Row style={{ marginTop: '0.5rem' }}>
            <Col md={6}>
              <FormGroup>
                <Label for="comentario-analista" style={{ fontWeight: 600 }}>Comentario Analista</Label>
                <Input
                  id="comentario-analista"
                  type="textarea"
                  value={comentarioAnalista || ""}
                  onChange={(event) => setComentarioAnalista(event.target.value)}
                />
                {!comentarioAnalista && (
                  <FormFeedback style={{ fontSize: "12px" }}>
                    Debe agregar un comentario de analista.
                  </FormFeedback>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="comentario-asegurado" style={{ fontWeight: 600 }}>Comentario al Asegurado</Label>
                <Input
                  id="comentario-asegurado"
                  type="textarea"
                  value={comentarioAsegurado || ""}
                  onChange={(event) => setComentarioAsegurado(event.target.value)}
                />
                {!rechazadoConComentario && (
                  <FormFeedback style={{ fontSize: "12px" }}>
                    Debe agregar un comentario al asegurado.
                  </FormFeedback>
                )}
              </FormGroup>
            </Col>
          </Row>
          <Col md={{ offset: 10 }} style={{ marginTop: 25 }}>
            <Row>
              <Col>
                <SafeBtn
                  loading={resolveLoading}
                  className="warning-accept w-100"
                  block
                  onClick={() => onResolution()}
                  disabled={
                    !checkIsValid() ||
                    warningTecho ||
                    !comentarioAnalista ||
                    !rechazadoConComentario ||
                    (!montoOtorgado && resolucion !== RESOLUCION_RECHAZADA && resolucion !== RESOLUCION_BLOQUEADA) ||
                    (resolucion === RESOLUCION_APROBADA_PARCIAL && montoOtorgado >= montoSolicitado) ||
                    (resolucion !== RESOLUCION_APROBADA_PARCIAL && resolucion !== RESOLUCION_RECHAZADA && resolucion !== RESOLUCION_BLOQUEADA && (poliza && montoOtorgado < poliza.umbral_cobertura_amt))                    // (resolucion === RESOLUCION_APROBADA_PARCIAL && montoOtorgado <= montoVigente) ||
                    // (resolucion === RESOLUCION_REDUCIDA && montoOtorgado <= 0) ||
                    // (resolucion === RESOLUCION_REDUCIDA && montoOtorgado >= montoVigente)
                  }
                  text=" Resolviendo"
                >
                  Resolver
                </SafeBtn>
              </Col>
            </Row>
            {warningTecho && (
              <FormFeedback style={{ fontSize: "12px" }}>
                Monto solicitado mayor a cúmulo disponible del deudor.
              </FormFeedback>
            )}
            {!isValidUserAndProfile && (
              <FormFeedback style={{ fontSize: "12px" }}>
                No es el analista asignado para resolver esta línea.
              </FormFeedback>
            )}
            {!isValidMontoSolicitado && (
              <FormFeedback style={{ fontSize: "12px" }}>
                <span>{invalidMontoError}</span>
              </FormFeedback>
            )}
            {!isValidResolucion && (
              <FormFeedback style={{ fontSize: "12px" }}>
                Ingrese un estado de resolución.
              </FormFeedback>
            )}
          </Col>
        </Col>
        <CheckModal
          isOpen={showResolveModal}
          toggle={() => history.push("/inbox-riesgos")}
          handleOk={() => history.push("/inbox-riesgos")}
          okBtnText="OK"
          confirmMsg="Solicitud Resuelta Satisfactoriamente."
        />
        <CheckModal
          isOpen={showSaveComment}
          toggle={() => setShowSaveComment(false)}
          handleOk={() => setShowSaveComment(false)}
          okBtnText="OK"
          confirmMsg="Comentario Guardado Satisfactoriamente."
        />
        <CarpetaResolucionModal
          isOpen={showCarpetaModal}
          toggle={() => history.push(`/inbox-riesgos/${movimiento.id}`)}
          handleOk={() => history.push("/inbox-riesgos")}
        />
        <WarningModal
          isOpen={showCarpetaWarning}
          toggle={() => setShowCarpetaWarning(false)}
          handleOk={() => {
            setShowCarpetaWarning(false);
          }}
          okBtnText="Aceptar"
          confirmMsg="Ha ocurrido un error al actualizar la carpeta tributaria"
          onlyCancelButton
        />
        <WarningModal
          isOpen={showModal}
          toggle={() => setShowModal(false)}
          handleOk={() => {
            setShowModal(false);
          }}
          okBtnText="Aceptar"
          confirmMsg={`Ha ocurrido un error al guardar resolución: ${modalErrorMessage}`}
          onlyCancelButton
        />
        <ComentarioResolucionModal
          openModal={openModal}
          toggleModal={toggleModal}
          movimientoId={movimiento.id}
          getMovimiento={getMovimiento}
          notificables={notificables}
          rutDeudor={movimiento.rut_deudor}
          setShowSaveComment={setShowSaveComment}
        />
        <WarningModal
          isOpen={openWarningModal}
          toggle={toggleWarningModal}
          handleOk={() => setOpenWarningModal(false)}
          loading={false}
          confirmMsg="Reporte Consolidado inexistente"
          cancelBtnText="OK"
          onlyCancelButton
        />
      </>
    )
  );
};

export default ResolucionForm;
